import { Choice, SkipNav } from "@cmsgov/ds-medicare-gov";
import React, { FunctionComponent } from "react";
import { formatStringPhone, useTranslate } from "../../../helpers";
import { toTitleCase } from "../../../helpers/formatHelpers";
import { normalizeStringCase } from "../helpers";
import { ToggledFrom } from "../types";
import { SimplePharamcyNetworkStatus } from "./SimplePharmacyNetworkStatus";
import { labelIdSuffix, nameIdSuffix } from "./constants";

export const PharmacyCard: FunctionComponent<{
  address: string;
  index: number;
  isSelected: boolean;
  inNetwork: boolean;
  handleToggle: (
    toggledFrom?: ToggledFrom
  ) => (npi: string | number, pharmacyNumber: number) => void;
  name: string;
  npi: string;
  pharmacyAnchorTarget: string;
  pharmacyNumber: number;
  phone: string;
  preferred: boolean;
  shouldShowSkipNav: boolean;
  shouldShowNetworkStatus: boolean;
}> = ({
  address,
  index,
  inNetwork,
  isSelected,
  handleToggle,
  name,
  npi,
  pharmacyAnchorTarget,
  pharmacyNumber,
  phone,
  preferred,
  shouldShowSkipNav,
  shouldShowNetworkStatus,
}) => {
  const t = useTranslate();
  const pharmacyNameId = `${npi}${nameIdSuffix}`;
  const pharmacyLabelId = `${npi}${labelIdSuffix}`;
  return (
    <li
      className="SelectPharmaciesPage__pharmacyCard"
      key={npi}
      id={npi}
      role="listitem"
    >
      <div className="ds-u-display--flex">
        <span className="SelectPharmaciesPage__pharmacyNumber">
          {pharmacyNumber}.
        </span>
        <div className="SelectPharmaciesPage__pharmacyInfo">
          <h2
            id={pharmacyNameId}
            className={`SelectPharmaciesPage__pharmacyCardHeader ${shouldShowNetworkStatus &&
              "ds-u-margin-bottom--0"} `}
          >
            {toTitleCase(normalizeStringCase(name))}
          </h2>
          <p className="ds-u-margin--0 SelectPharmaciesPage__pharmacyCard__status-container">
            {shouldShowNetworkStatus && (
              <SimplePharamcyNetworkStatus {...{ inNetwork, preferred }} />
            )}
          </p>
          <p className="ds-u-margin--0">
            {address}
            <br />
            {formatStringPhone(phone)}
          </p>
        </div>
      </div>
      <div className="SelectPharmaciesPage__addPharmacy">
        <Choice
          type="checkbox"
          name="pharmacy-1"
          value={npi}
          className={`SelectPharmaciesPage__pharmaciesOption e2e-select-pharmacy-${index}`}
          checked={isSelected}
          onChange={(): void => handleToggle()(npi, pharmacyNumber)}
          aria-labelledby={`${pharmacyNameId} ${pharmacyLabelId}`}
        >
          <span id={pharmacyLabelId}>
            {/* Add sr-only comma and space for screen-reader intelligibility */}
            <span className="ds-u-visibility--screen-reader">{`, `}</span>
            {isSelected
              ? t("pharm_selection.pharmacy_added")
              : t("pharm_selection.add_pharmacy")}
          </span>
        </Choice>
      </div>

      {shouldShowSkipNav && (
        <SkipNav
          href={`#${pharmacyAnchorTarget}`}
          onClick={(e): void => {
            e.preventDefault();
            document.getElementById(pharmacyAnchorTarget)?.focus();
          }}
        >
          {t("pharmacy_skip_text")}
        </SkipNav>
      )}
    </li>
  );
};
